import { useEffect } from "react";
import { Link } from "react-router-dom";
import AdminPageLayout from "../../../../components/midpoint/admin/layout/AdminPageLayout";
import AdminPageHeader from "../../../../components/midpoint/admin/layout/AdminPageHeader";
import { AdminAutomotiveNav } from "../../automotive/AdminAutomotiveNav";
import {
  MARKETPLACE_DATE_RANGES,
  trackMarketplaceAnalyticsEvent,
} from "../../../../constants/automapMarketplaceAnalyticsConstants";
import { AdminAnalyticsNav, AnalyticsRangeSelect } from "../AdminAnalyticsShared";

export function AdminMarketplaceAnalyticsNav({ active = "marketplace" }) {
  const items = [
    { key: "marketplace", label: "Resumen", href: "/admin/analytics/marketplace" },
    { key: "supply", label: "Oferta", href: "/admin/analytics/supply" },
    { key: "demand", label: "Demanda", href: "/admin/analytics/demand" },
    { key: "cities", label: "Ciudades", href: "/admin/analytics/cities" },
    { key: "pricing", label: "Precios", href: "/admin/analytics/pricing" },
    { key: "inventory-health", label: "Inventario", href: "/admin/analytics/inventory-health" },
    { key: "trust-safety", label: "Confianza", href: "/admin/analytics/trust-safety" },
    { key: "seo", label: "SEO", href: "/admin/analytics/seo" },
    { key: "campaigns", label: "Campañas", href: "/admin/analytics/campaigns" },
    { key: "dealers", label: "Concesionarios", href: "/admin/analytics/dealers" },
  ];

  return (
    <nav className="admin-console__nav-tabs admin-analytics-nav admin-marketplace-nav">
      {items.map((item) => (
        <Link key={item.key} to={item.href} className={active === item.key ? "is-active" : undefined}>
          {item.label}
        </Link>
      ))}
    </nav>
  );
}

export function MarketplaceAnalyticsShell({
  active,
  title,
  description,
  range,
  onRangeChange,
  viewEvent,
  children,
  toolbarExtra = null,
}) {
  useEffect(() => {
    if (viewEvent) trackMarketplaceAnalyticsEvent(viewEvent, { range });
  }, [viewEvent, range]);

  const handleRangeChange = (next) => {
    trackMarketplaceAnalyticsEvent("marketplace_analytics_date_range_changed", { range: next });
    onRangeChange(next);
  };

  return (
    <AdminPageLayout>
      <AdminPageHeader eyebrow="AutoMapa · Marketplace Analytics" title={title} description={description} />
      <AdminAutomotiveNav active="analytics" />
      <AdminAnalyticsNav active="marketplace" />
      <AdminMarketplaceAnalyticsNav active={active} />
      <main className="admin-console__main wrap">
        <div className="dealer-inventory-toolbar">
          <AnalyticsRangeSelect range={range} onChange={handleRangeChange} options={MARKETPLACE_DATE_RANGES} />
          {toolbarExtra}
        </div>
        {children}
      </main>
    </AdminPageLayout>
  );
}

export function RecommendedActionsPanel({ actions, onActionClick }) {
  if (!actions?.length) {
    return (
      <section className="dealer-state-box">
        <h3>Acciones recomendadas</h3>
        <p className="muted">Sin acciones prioritarias en este periodo.</p>
      </section>
    );
  }
  return (
    <section className="dealer-state-box">
      <h3>Acciones recomendadas</h3>
      <ul className="admin-dashboard__activity-feed">
        {actions.map((action) => (
          <li key={action.id}>
            <Link
              to={action.link}
              onClick={() => {
                trackMarketplaceAnalyticsEvent("marketplace_recommended_action_clicked", {
                  actionId: action.id,
                });
                onActionClick?.(action);
              }}
            >
              [{action.priority}] {action.message}
            </Link>
          </li>
        ))}
      </ul>
    </section>
  );
}

export function ActionLinksPanel({ links }) {
  if (!links?.length) return null;
  return (
    <section className="dealer-state-box">
      <h3>Acciones rápidas</h3>
      <div style={{ display: "flex", gap: "0.5rem", flexWrap: "wrap" }}>
        {links.map((link) => (
          <Link key={link.href} className="dealer-portal-btn" to={link.href}>
            {link.label}
          </Link>
        ))}
      </div>
    </section>
  );
}
